import { Language, LanguageType } from "../objects/languages.object";

export function flipLanguage(current: LanguageType): LanguageType {
  const [lang1, lang2] = Object.keys(Language) as [LanguageType, LanguageType];
  return current === lang1 ? lang2 : lang1;
}